import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotGossipSection from './components/HotGossipSection';
import TrackingSection from './components/TrackingSection';
import VideoAreaSection from './components/VideoAreaSection';
import CategorySection from './components/CategorySection';
import NewsletterSection from './components/NewsletterSection';
import { siteConfig } from '@/mocks/homeData';

export default function Home() {
  useEffect(() => {
    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          name: siteConfig.name,
          url: siteConfig.url,
          description: siteConfig.description,
          sameAs: ['http://shangremen.cn/'],
        },
        {
          '@type': 'WebSite',
          name: siteConfig.name,
          url: siteConfig.url,
          description: siteConfig.description,
          potentialAction: {
            '@type': 'SearchAction',
            target: {
              '@type': 'EntryPoint',
              urlTemplate: `${siteConfig.url}/search?q={search_term_string}`,
            },
            'query-input': 'required name=search_term_string',
          },
        },
        {
          '@type': 'WebPage',
          name: `${siteConfig.name} - 首页`,
          description: siteConfig.description,
          url: siteConfig.url,
          isPartOf: {
            '@type': 'WebSite',
            name: siteConfig.name,
            url: siteConfig.url,
          },
        },
      ],
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotGossipSection />
        <TrackingSection />
        <VideoAreaSection />
        <CategorySection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}